/** biome-ignore-all lint/security/noDangerouslySetInnerHtml: <explanation> */
import { Avatar } from "@base-ui/react/avatar";
import Link from "next/link";
import MessageIcon from "@/components/icons/message";
import LikeIcon from "@/components/icons/like";
import BookmarkIcon from "@/components/icons/bookmark";
import TopicImages from "@/app/(main)/forum/_components/topic-images";
import type { Topic } from "@/app/(main)/forum/_components/types";

const IMAGE_LENGTH = 3;
const SearchTopicCard = ({ topic }: { topic: Topic }) => {
  const categoryLabel = topic.category.parent
    ? `${topic.category.parent.name} / ${topic.category.name}`
    : topic.category.name;

  return (
    <div className="rounded-2xl border border-neutral-200 bg-background p-4 flex flex-col gap-3">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <Avatar.Root className="inline-flex size-10 items-center justify-center overflow-hidden rounded-full bg-gray-100 shrink-0">
            <Avatar.Image
              className="size-full object-cover"
              draggable="false"
              height="40"
              src={topic.user.avatarUrl}
              width="40"
            />
            <Avatar.Fallback className="flex size-full items-center justify-center text-sm font-medium text-gray-700">
              {topic.user.name
                .split(" ")
                .map((w) => w[0])
                .join("")}
            </Avatar.Fallback>
          </Avatar.Root>
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <span className="text-sm font-semibold leading-4.5">
                {topic.user.name}
              </span>
              <span className="text-xs text-neutral-400">
                {topic.createdAtLabel}
              </span>
            </div>
            <span className="text-xs text-neutral-500">
              {topic.user.title ?? "Üye"}
            </span>
          </div>
        </div>
      </div>

      <span className="text-xs text-neutral-400">{categoryLabel}</span>

      <div className="flex flex-col gap-1">
        <Link className="hover:underline" href={`/forum/topic/${topic.id}`}>
          <h2 className="font-bold text-base leading-5">{topic.title}</h2>
        </Link>
        <p
          className="text-sm text-neutral-700 line-clamp-2"
          dangerouslySetInnerHTML={{ __html: topic.text }}
        />
      </div>

      {topic.imageUrls.length > 0 && (
        <TopicImages
          imageUrls={topic.imageUrls.slice(0, IMAGE_LENGTH)}
          title={topic.title}
        />
      )}

      <div className="flex items-center justify-between text-sm font-semibold text-neutral-400">
        <div className="flex items-center gap-3">
          <span className="inline-flex items-center gap-1">
             <Link className="group" href={`/forum/topic/${topic.id}`}>
               <LikeIcon className="size-6 stroke-[1.5] stroke-neutral-400 group-hover:fill-brand-blue-500 group-hover:stroke-brand-blue-500" />
             </Link>
             {topic.likeCount}
          </span>
          <span className="inline-flex items-center gap-1">
            <Link className="group" href={`/forum/topic/${topic.id}`}>
              <MessageIcon className="stroke-neutral-400 size-6 stroke-[1.5] group-hover:stroke-brand-blue-500" />
            </Link>
            {topic.replyCount}
          </span>
        </div>
        <div className="flex items-center gap-1">
          <Link className="group" href={`/forum/topic/${topic.id}`}>
            <BookmarkIcon className="size-6 stroke-[1.5] stroke-neutral-400 fill-none group-hover:stroke-brand-blue-500 group-hover:fill-brand-blue-100" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SearchTopicCard;
